import { render, staticRenderFns } from "./DialogCreateClient.vue?vue&type=template&id=60181c63&scoped=true"
import script from "./DialogCreateClient.vue?vue&type=script&lang=ts"
export * from "./DialogCreateClient.vue?vue&type=script&lang=ts"
import style0 from "./DialogCreateClient.vue?vue&type=style&index=0&id=60181c63&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60181c63",
  null
  
)

export default component.exports